import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useMedia } from "react-media";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getImageGalleries } from "../../api/api";
import { GLOBAL_MEDIA_QUERIES, secondaryColors } from "../../constatnts";
import { Gallery } from "../../types/gallery";
import { IMedia } from "../../types/types";

const data = [1, 2, 3, 4, 5];
const ImageGallery = () => {
  const { t, i18n } = useTranslation();

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  const { isLoading,  data}: any = useQuery(
    "ImageGalleriesData",
    () =>
      getImageGalleries({
        language: i18n.language,
      })
  );

  if (isLoading) return <div></div>;

  console.log(data);
  return (
    <Container {...matches}>
      {data.data.map((item: Gallery, index: number) => (
        <SLink to={`/gallery/${item.id}`}>
          <GalleryCard {...item} />
        </SLink>
      ))}
    </Container>
  );
};

const GalleryCard = (props: Gallery) => {
  return (
    <GalleryCardContainer>
      <ImageContainer
        src={`${process.env.REACT_APP_CMS}${props.images[0]?.url}`}
      />
      <CardTitle>{props.title}</CardTitle>
    </GalleryCardContainer>
  );
};

const SLink = styled(Link)`
  text-decoration: none;
  color: #333;
`;
const Container = styled.div<IMedia>`
  display: grid;
  grid-template-columns: ${(props) => (props.large ? "1fr 1fr 1fr" : "1fr")};
  grid-column-gap: 20px;
  grid-row-gap: 40px;
`;
const CardTitle = styled.h3`
  color: ${secondaryColors[0]};
`;
const GalleryCardContainer = styled.div`
  transition: 600ms;
  &:hover {
    transform: scale(1.05);
  }
`;

interface IImageContainer {
  src: string | null | undefined;
}
const ImageContainer = styled.div<IImageContainer>`
  height: 250px;
  background-color: grey;
  background-size: cover;
  background-image: url("${(props) => props.src}");
`;

const Spacer = styled.div`
  height: 20px;
  width: 20px;
`;
const Section = styled.div``;
const Title = styled.h1``;
export default ImageGallery;
